import styled from 'styled-components';
import { media, layout } from '@prisjakt/ui-base';
import Button from '@prisjakt/ui-button';
import { DeliveryTimeExperimentType } from 'src/hooks/experiments';

const desktopPadding = layout.spacing.xSmall;
const circularButtonHeight = 24;

interface IDeliveryTimeExperimentVal {
  deliveryTimeExperimentVal?: DeliveryTimeExperimentType;
}

export const LinkDesktop = styled(Button)<IDeliveryTimeExperimentVal>`
  width: 100%;
  white-space: normal;
  text-transform: none;
  padding: ${desktopPadding} 0 ${desktopPadding} ${desktopPadding};
  ${media.mediumDown`
    display: none;
  `}
  background-color: ${props =>
    props.deliveryTimeExperimentVal === 'green button'
      ? props.theme.colors.positive700
      : props.theme.colors.maybeBlue500};
`;

export const HideOnDesktop = styled.div`
  ${media.largeUp`
      display: none;
    `}
`;

export const StoreLink = styled.div`
  display: flex;
  align-items: center;
`;

export const CircularButton = styled.div<IDeliveryTimeExperimentVal>`
  background-color: ${props =>
    props.deliveryTimeExperimentVal === 'green button'
      ? props.theme.colors.positive700
      : props.theme.colors.maybeBlue500};
  width: ${circularButtonHeight}px;
  height: ${circularButtonHeight}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: ${circularButtonHeight / 2}px;
`;
